import React, { PureComponent, useContext } from "react";

import { GlobalContext } from "../../globals/globalContext.jsx";
import Template from "./Register.jsx";
import "./styles.styl";

export default class RegisterController extends PureComponent {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab || "profile",
    };
    this.handlers = {
      onProfileSuccess: this.onProfileSuccess.bind(this),
      onPaymentSuccess: this.onPaymentSuccess.bind(this),
    };
  }

  onProfileSuccess(customer, newDeliveryAddress = undefined) {
    const { onChange } = this.props;
    const { setSubscription, setDeliveryAddress } = this.context;

    this.setState({ activeTab: "payment", customer }, () => {
      setSubscription((prevSubscription) => ({
        ...prevSubscription,
        customer: customer,
      }));

      if (newDeliveryAddress) {
        setDeliveryAddress(newDeliveryAddress);
      }

      onChange && onChange(this.context.subscription);
    });
  }

  onPaymentSuccess(customer) {
    const { onSuccess } = this.props;
    const { setSubscription, setShouldRegister } = this.context;

    setSubscription((prevSubscription) => ({
      ...prevSubscription,
      customer: customer,
    }));
    setShouldRegister(!customer.is_registered);

    onSuccess && onSuccess(customer);
  }

  render() {
    return <Template {...this.props} {...this.state} {...this.handlers} />;
  }
}
